/**
 * @param {String|Number} value
 * @return {string}
 */
export function formatNumber(value) {
    return new Intl.NumberFormat('cs').format(value);
}
